import React from 'react';
import { View, Text, TextInput, ScrollView, Alert } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import get from "../../api/methods/get";
import {CREATE_REVIEW, GET_SPECIFIC_DELIVERABLE} from "./api/deliveryEndpoints";
import {ButtonWithSpinner, Card, InformationDialogue, Spacing, SpinnerControl, SpinnerDialogue} from "../../components";
import SelectableImage from '../../components/SelectableImage';
import {formatDate} from "../../constants/formatDate";
import RatingComponent from "../../components/rating/RatingComponent";
import {stringIsEmpty} from "../../constants/StringChecker";
import post from "../../api/methods/post";
import NavBar from "../../components/NavBar";

class DeliveryReviewScreen extends React.Component {

    state = {
        showOriginalContent: true,
        originalContent: null,
        fetchingOriginalContent: false,

        isSendingReview: false,
        reviewText: "",
        reviewStars: 0,

        showSuccessModal: false,
        showErrorModal: false,
        errorMessage: "",
    }

    handleSend = async () => {
        if (this.state.isSendingReview) return;
        this.setState({ isSendingReview: true });

        try {
            const userId = this.props.userId;
            const { journeyId, deliverableId } = this.state.originalContent;
            const { reviewStars, reviewText } = this.state;

            const payload = {
                journeyId: journeyId,
                deliverableId: deliverableId,
                reviewerId: userId,
                reviewPoints: reviewStars,
                reviewComment: reviewText
            }

            let result = await post(CREATE_REVIEW, payload);

            this.setState({
                showSuccessModal: true,
            })

            // Alert.alert(
            //     "Sucesso!",
            //     "Enviamos a sua avaliação com sucesso! Obrigado por ajudar a melhorar o aprendizado do seu colega!",
            //     [
            //         {
            //             text: 'Continuar',
            //             onPress: () => this.props.navigation.goBack()
            //         }
            //     ]
            // )

        } catch (e) {
            console.log(e);
            this.setState({
                showErrorModal: true,
                errorMessage: "Aconteceu um erro ao enviar a sua avaliação! Tente novamente mais tarde!"
            });
        }

        this.setState({ isSendingReview: false });
    }

    fetchOriginalContent = async () => {

        if (this.state.fetchingOriginalContent) return;
        this.setState({ fetchingOriginalContent: true })

        try {
            const data = this.props.location.state.deliveryData;
            const journeyId = data.journeyId;
            const deliverableId = data.deliverableId;

            let result = await get(GET_SPECIFIC_DELIVERABLE(journeyId, deliverableId));
            let json = await result.json();

            this.setState({ originalContent: json.data })

        } catch (e) {

        }

        this.setState({ fetchingOriginalContent: false })
    }

    renderOriginalContent = () => {

        if (this.state.originalContent === null) return;

        const { title, description, images, GSI1PK, createdAt } = this.state.originalContent;

        return (
            <Card containerStyle={{ margin: 20, padding: 8 }}>

                <Text style={{ fontSize: 18, color: 'white' }}>
                    { title }
                </Text>
                <Spacing height={6} />
                <Text style={{ fontSize: 16, color: 'white' }}>
                    { description }
                </Text>
                <Spacing height={12} />

                {
                    images.length > 0 &&
                        <View>
                            <Text style={{ fontSize: 18, color: 'white' }}>
                                Imagens:
                            </Text>
                            <Spacing height={6} />
                            <ScrollView horizontal={true}>
                                {
                                    images.map(item => {
                                        const imageData = 'data:image/jpeg;base64,' + item.image;
                                        return (
                                        	<SelectableImage
                                        		imageData={imageData}
                                        		style={{ borderRadius: 8}}
                                        		imageSize={{ width: 80, height: 140 }}
                                        	/>
                                        )
                                    })
                                }
                            </ScrollView>
                            {/*<Text style={{ fontSize: 14, color: 'white', alignSelf: 'center' }}>*/}
                            {/*    Clique nas imagens para ampliar!*/}
                            {/*</Text>*/}
                        </View>
                }

                <Spacing height={12} />
                <Text style={{ fontSize: 12, color: 'white' }}>
                    {`Enviado em ${formatDate(createdAt)}`}
                </Text>

                {/*<Text style={{ fontSize: 12, color: 'white' }}>*/}
                {/*    {`Enviado por ${GSI1PK} em ${formatDate(createdAt)}`}*/}
                {/*</Text>*/}

            </Card>
        )

    }

    renderReviewArea = () => {
        if (this.state.originalContent === null) return;

        return (
            <Card containerStyle={{ margin: 20, padding: 8 }}>

                <Text style={{ fontSize: 18, color: 'white', fontWeight: 'bold' }}>
                    Avaliação:
                </Text>

                <RatingComponent
                    handleOnPress={(newValue) => this.setState({ reviewStars: newValue })}
                    title={'Avaliação'}
                    titleTextProps={{ color: 'white' }}
                />


                <Text style={{ fontSize: 18, color: 'white', fontWeight: 'bold' }}>
                    Comentários:
                </Text>

                <TextInput
                    style={{ backgroundColor: 'white', color: 'black', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                    value={this.state.reviewText}
                    placeholder={"Qualquer comentário que você queira enviar!"}
                    placeholderTextColor={'gray'}
                    onChangeText={(newValue) => this.setState({ reviewText: newValue })}
                    multiline
                />

                <Spacing height={12} />

                <ButtonWithSpinner
                    isLoading={this.state.isSendingReview}
                    text={'Enviar'}
                    onPress={this.handleSend}
                    containerPropsStyle={{ height: 30, borderRadius: 8 }}
                    textPropsStyle={{ fontSize: 18 }}
                />

            </Card>
        )

    }

    componentDidMount() {
        this.fetchOriginalContent()
    }

    render() {

        return (
            <NavBar title={"Avaliar"}>

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={this.state.errorMessage}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Enviamos a sua revisão com sucesso!"}
                    buttons={[
                        {
                            text: "Continuar",
                            onPress: () => this.props.history.goBack()
                        }
                    ]}
                />

                <SpinnerDialogue
                    isModalVisible={this.state.isSendingReview}
                    onClose={() => {}}
                    isFinished={!this.state.isSendingReview}
                    titleProps={"Enviando"}
                    messageProps={"Estamos enviando sua revisão!"}
                />

                <SpinnerControl
                    isFetching={this.state.fetchingOriginalContent}
                    text={"Carregando a aplicação que vai ser avaliada!"}
                />

                <View style={{ width: 600 }}>
                    { this.renderOriginalContent() }
                    { this.renderReviewArea() }
                </View>

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId
    }
}

export default connect(mapStateToProps)(DeliveryReviewScreen);

